import { io } from "socket.io-client";

export const SESSION_REPLACED_EVENT = "quest:sessionReplaced";

let socket = null;
let sessionReplaced = false;

const getAuthTokenFromStorage = () => {
  try {
    const persistedRoot = localStorage.getItem("persist:root");
    if (!persistedRoot) return null;

    const root = JSON.parse(persistedRoot);
    if (!root?.auth || root.auth === "undefined") return null;

    const auth = JSON.parse(root.auth);
    return auth?.token || null;
  } catch {
    return null;
  }
};

export const teardownSocket = () => {
  if (!socket) return;
  const current = socket;
  socket = null;
  try {
    current.removeAllListeners();
    current.disconnect();
  } catch (_) {
    // Ignore teardown races during logout / tab close.
  }
};

export const setupSocket = () => {
  if (socket) return socket;

  const token = getAuthTokenFromStorage();
  if (!token) return null;

  const SOCKET_URL =
    process.env.REACT_APP_CLIENT_ENV === "development"
      ? process.env.REACT_APP_LOCAL_SOCKET_URL
      : process.env.REACT_APP_SERVER_SOCKET_URL;

  if (!SOCKET_URL) return null;

  sessionReplaced = false;
  socket = io(SOCKET_URL, {
    transports: ["websocket"],
    auth: {
      token: token,
    },
  });

  socket.on("sessionReplaced", () => {
    sessionReplaced = true;
    try {
      window.dispatchEvent(new Event(SESSION_REPLACED_EVENT));
    } catch (_) {
      // Non-browser / test environments.
    }
    teardownSocket();
  });

  socket.on("disconnect", (reason) => {
    // Do not reconnect after an intentional kick (sessionReplaced) or logout teardown.
    if (sessionReplaced || !socket) return;
    if (reason === "io server disconnect" && getAuthTokenFromStorage()) {
      socket.connect();
    }
  });

  return socket;
};

export default setupSocket;
